import { render, staticRenderFns } from "./formAdditionalData.vue?vue&type=template&id=9b67eeea&scoped=true"
import script from "./formAdditionalData.vue?vue&type=script&lang=js"
export * from "./formAdditionalData.vue?vue&type=script&lang=js"
import style0 from "./formAdditionalData.vue?vue&type=style&index=0&id=9b67eeea&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b67eeea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b67eeea')) {
      api.createRecord('9b67eeea', component.options)
    } else {
      api.reload('9b67eeea', component.options)
    }
    module.hot.accept("./formAdditionalData.vue?vue&type=template&id=9b67eeea&scoped=true", function () {
      api.rerender('9b67eeea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/trailer/components/form/steps/formAdditionalData.vue"
export default component.exports